export const sacrificialDeadlyToddlersTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('DG:DeadlyToddlers') !== -1) {
			return {
				type: 'sacrificialDeadlyToddlersTest',
				color: 'IndianRed',
				title: 'Broken Deadly Toddlers mod by SACRIFICIAL',
				text: 'You\'re potentially using an outdated or broken version of Deadly Toddlers mod by SACRIFICIAL.',
				description: 'Remove all files related to the <strong>Deadly Toddlers</strong> mod and check if there is a recent update available.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>e911b5a74c777aca5bab1a4b</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-09-26 00:35:29</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.18.1020-1.200.000.364.Release</buildsignature>
        <categoryid>base_statistic_tracker.py:315</categoryid>
        <desyncid>e911b5a74c777aca5bab1a4b</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Exception applying attributes to object DG:DeadlyToddlers_Blood_Medium:0x0314082d9b4a02b6 (AttributeError: 'NoneType' object has no attribute 'add_if_not_in_tracker')
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\script_object.py&quot;, line 1679, in attributes
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\script_object.py&quot;, line 1677, in attributes
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\puddles\puddle.py&quot;, line 263, in load_object
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\puddles\puddle.py&quot;, line 225, in start_evaporation
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\commodity_tracker.py&quot;, line 62, in set_value
  File &quot;T:\InGame\Gameplay\Scripts\Server\statistics\base_statistic_tracker.py&quot;, line 315, in set_value
AttributeError: 'NoneType' object has no attribute 'add_if_not_in_tracker'
</desyncdata>
    </report>
</root>
*/

export const sacrificialExtremeViolenceTest = ({
    buildsignature,
    categoryid,
    createtime,
    desyncdata,
    desyncid,
    screenshot,
    sessionid,
    sku,
    systemconfig,
    type,
    version,
}) => {
    if (desyncdata !== undefined) {
        if (desyncdata.indexOf('DG:ExtremeViolence') !== -1) {
            return {
                type: 'sacrificialExtremeViolenceTest',
                color: 'IndianRed',
                title: 'Broken Extreme Violence mod by Sacrificial',
                text: 'You\'re using an outdated or broken version of Extreme Violence mod by Sacrificial.',
                description: 'Remove all files related to the <strong>Extreme Violence</strong> mod and check if there is a recent update available.'
            }
        }
    }
}

// EXAMPLES
/*
<root>
    <report>
        <version>2</version>
        <sessionid>9b604a8ab11b3dc35bbbdab9</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-10-08 18:40:57</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.18.1020-1.200.000.364.Release</buildsignature>
        <categoryid>social_super_interaction.py:788</categoryid>
        <desyncid>9b604a8ab11b3dc35bbbdab9</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Exception when applying action &lt;ReactionLootOp ParticipantType.Actor&gt; for loot &lt;class 'sims4.tuning.instances.DG:ExtremeViolence_SabotageOffendersReputation1_&quot;Reaction_ActionLoot&quot;'&gt; (AttributeError: 'NoneType' object has no attribute 'make_constraint_default')
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 205, in c_api_server_tick
  File &quot;T:\InGame\Gameplay\Scripts\Server\zone.py&quot;, line 470, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\broadcasters\broadcaster_service.py&quot;, line 524, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\broadcasters\broadcaster_service.py&quot;, line 594, in _update
  File &quot;T:\InGame\Gameplay\Scripts\Server\broadcasters\broadcaster.py&quot;, line 490, in apply_broadcaster_effect
  File &quot;T:\InGame\Gameplay\Scripts\Server\broadcasters\broadcaster_effect.py&quot;, line 79, in apply_broadcaster_effect
  File &quot;T:\InGame\Gameplay\Scripts\Server\broadcasters\broadcaster_effect.py&quot;, line 569, in _apply_broadcaster_effect
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\loot.py&quot;, line 373, in apply_to_resolver
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\loot.py&quot;, line 371, in apply_to_resolver
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\loot_basic_op.py&quot;, line 211, in apply_to_resolver
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\reactions.py&quot;, line 358, in _apply_to_subject_and_target
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\reactions.py&quot;, line 320, in _push_si_reaction
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\reactions.py&quot;, line 123, in __call__
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\sim.py&quot;, line 3467, in push_super_affordance
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\aop.py&quot;, line 236, in test_and_execute
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\aop.py&quot;, line 224, in execute
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\aop.py&quot;, line 212, in execute_interaction
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\interaction_queue.py&quot;, line 1313, in append
  File &quot;T:\InGame\Gameplay\Scripts\Lib\contextlib.py&quot;, line 55, in __exit__
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\interaction_queue.py&quot;, line 860, in _head_change_watcher
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\interaction_queue.py&quot;, line 944, in _get_head
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\interaction_queue.py&quot;, line 339, in get_next_unblocked_interaction
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\social\social_super_interaction.py&quot;, line 157, in get_sims_with_invalid_paths
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\social\social_super_interaction.py&quot;, line 101, in test_constraint_compatibility
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\si_state.py&quot;, line 150, in are_sis_compatible
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\si_state.py&quot;, line 118, in _test_constraint_intersection
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\si_state.py&quot;, line 92, in _get_constraint_intersection_for_sis
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 3969, in constraint_intersection
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 3870, in constraint_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\social\social_super_interaction.py&quot;, line 824, in _constraint_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 3870, in constraint_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\social\social_super_interaction.py&quot;, line 788, in _constraint_gen
AttributeError: 'NoneType' object has no attribute 'make_constraint_default'
</desyncdata>
    </report>
</root>
*/


// WEBPACK FOOTER //
// ./src/tests/mods/authors/sacrificialModsTest.js